import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function getScreenCollection(
  authState: tsWhoAmI,
  collection_id: number | string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/screen/getScreenCollection.php?ScreenCollectionID=${collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateScreenCollectionStatus(
  authState: tsWhoAmI,
  collection_id: number | string,
  status: string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/screen/updateScreenCollection.php?ScreenCollectionID=${collection_id}&CollectionStatus=${status}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getScreenCollectionSampleRuns(
  authState: tsWhoAmI,
  collection_id: number | string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/screen/getCollectionSampleRuns.php?ScreenCollectionID=${collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const ScreenCollectionService = {
  getScreenCollection,
  getScreenCollectionSampleRuns,
  updateScreenCollectionStatus,
}

export default ScreenCollectionService
